import * as client from "../ClientConsumer";
import { generatePath } from "react-router-dom";
import { GPTCommentSuggestionListType } from "../../Presentation/Components/Comment/GeneratedComments/ContentSuggestion.types";

const routes = {
    GET_GENERATED_COMMENTS: "/suggestion/post/:postId",
};

export async function getGeneratedComments(
    postId: string,
): Promise<GPTCommentSuggestionListType> {
    return client
        .getData(
            generatePath(routes.GET_GENERATED_COMMENTS, {
                postId: postId,
            }),
        )
        .then((res) => res.data);
}
